import { SECTION_SLUGS } from "../../constants/sections";
import { BROWSER_STORAGE } from "../../redux/constants";

import {
  getCountrySettings,
  setCommonData,
  getConfigurationSettings
} from "../../redux/actions/common.action";
import { getMegaMenuData } from "../../redux/actions/megaMenu.action";
import { getBannerSections } from "../../redux/actions/section.action";
import { fetchFooterData } from "../../redux/actions/footer.action";
import { getCartAndWishlistGeneralData } from "@/redux/actions/cart.action";
import { fetchLoyaltyDetails } from "@/redux/actions/myAccount.action";

import { handleLoadTask, getStoreId } from "./helpers";
import { PageLoadStrategy } from "./types";

export const loadCommonGlobalData: PageLoadStrategy = async data => {
  const state = data.store.getState();
  const isUserLoggedIn = state.authReducer.userLoggedIn;

  const sequentialTasks: PageLoadStrategy[] = [
    ...(isUserLoggedIn ? [loadLoyaltyDetails] : []),
    loadCountrySettings
  ];

  const parallelTasks: PageLoadStrategy[] = [loadConfigurations, handleCountry];

  for (const task of sequentialTasks) {
    await handleLoadTask(task, data);
  }

  await Promise.all(parallelTasks.map(task => handleLoadTask(task, data)));
};

export const loadClientGlobalData: PageLoadStrategy = async data => {
  const parallelTasks: PageLoadStrategy[] = [
    fetchMegaMenu,
    loadHeaderSections,
    loadFooter,
    loadCartAndWishlistBriefData
  ];

  await Promise.all(parallelTasks.map(task => handleLoadTask(task, data)));
};

const loadCountrySettings: PageLoadStrategy = ({ store, url, language }) => {
  return store.dispatch(getCountrySettings(language, null, url));
};

const fetchMegaMenu: PageLoadStrategy = async ({
  store,
  url,
  language,
  cookies
}) => {
  const storeId = getStoreId({ store: store, url: url });
  const country = store.getState().common.settings;

  return store.dispatch(
    getMegaMenuData(language, storeId, country?.countryId, cookies)
  );
};

const loadHeaderSections: PageLoadStrategy = async ({ store }) => {
  await store.dispatch(getBannerSections(SECTION_SLUGS.HEADER));
};

const loadConfigurations: PageLoadStrategy = async ({ store }) => {
  await store.dispatch(getConfigurationSettings());
};

const loadFooter: PageLoadStrategy = async ({ store }) => {
  await store.dispatch(fetchFooterData());
};

const loadCartAndWishlistBriefData: PageLoadStrategy = async ({ store }) => {
  return store.dispatch(getCartAndWishlistGeneralData());
};

const loadLoyaltyDetails: PageLoadStrategy = async ({ store }) => {
  return store.dispatch(fetchLoyaltyDetails());
};

const handleCountry: PageLoadStrategy = ({ store, url, cookies }) => {
  const { common } = store.getState();
  const userCountry = cookies[BROWSER_STORAGE.USER_COUNTRY];

  let country = null,
    countryAE = {},
    selectedCountry = null,
    selectedIPCountry = null,
    countryCookie = null,
    countryData = common.countryData || [];

  countryData.map(_country => {
    if (
      url.includes(`/en-${_country.countrySHORT.toLowerCase()}`) ||
      url.includes(`/ar-${_country.countrySHORT.toLowerCase()}`)
    ) {
      selectedCountry = _country;
    }
    if (_country.countrySHORT === userCountry) {
      countryCookie = _country;
    }
    if (_country.countrySHORT === "AE") {
      countryAE = _country;
    }
    if (
      common.ipCountryData &&
      common.ipCountryData.countrySHORT &&
      common.ipCountryData.countrySHORT === _country.countrySHORT
    ) {
      selectedIPCountry = _country;
    }
    return null;
  });

  if (selectedCountry) {
    country = selectedCountry;
    store.dispatch(setCommonData(selectedCountry));
  } else if (!selectedCountry) {
    if (countryCookie) {
      country = countryCookie;
      store.dispatch(setCommonData(countryCookie));
    } else if (selectedIPCountry) {
      country = selectedIPCountry;
      store.dispatch(setCommonData(selectedIPCountry));
    } else {
      country = countryAE;
      store.dispatch(setCommonData(countryAE));
    }
  }
};
